import { NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { InfoModalContent } from './models/info-popup-modal.interface';

@Component({
  standalone: true,
  selector: 'idp-info-modal-mach-core',
  templateUrl: './info-modal-mach-core.component.html',
  styleUrls: ['./info-modal-mach-core.component.scss'],
  imports: [NgIf]
})
export class InfoModalMachCoreComponent {
  @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;
  @Input() set showDialog(showDialog: boolean) {
    if (showDialog && this.dialog?.nativeElement) {
      this.dialog.nativeElement.showModal();
    }
  }

  @Input() content!: InfoModalContent;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  protected closeDialog() {
    this.dialog.nativeElement.close();
    this.close.emit();
  }
}
